(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Parallax on the hero background image, lerp-smoothed each frame so it
  // trails the scroll position slightly instead of snapping 1:1 to it.
  function initParallax() {
    if (reduceMotion) return;

    var heroes = Array.prototype.slice.call(document.querySelectorAll('[data-max-parallax]'));
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      hero._maxParallaxCurrent = 0;
      hero._maxParallaxTarget = 0;
    });

    function readTargets() {
      heroes.forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        hero._maxParallaxInView = rect.bottom > 0 && rect.top < window.innerHeight;
        hero._maxParallaxTarget = rect.top * -0.12;
      });
    }

    function tick() {
      heroes.forEach(function (hero) {
        if (!hero._maxParallaxInView) return;
        hero._maxParallaxCurrent += (hero._maxParallaxTarget - hero._maxParallaxCurrent) * 0.09;
        hero.style.setProperty('--max-parallax-y', hero._maxParallaxCurrent.toFixed(2) + 'px');
      });
      window.requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', readTargets, { passive: true });
    window.addEventListener('resize', readTargets, { passive: true });
    readTargets();
    window.requestAnimationFrame(tick);
  }

  // Toggles a class on the sticky header once the page has scrolled past
  // the top, so it can pick up a frosted-glass background + shadow.
  function initHeaderScrollState() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var ticking = false;

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // Smooth-scrolls same-page anchor links (e.g. "Our Story" -> #story).
  function initSmoothAnchors() {
    if (reduceMotion) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href').slice(1);
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Subtle magnetic pull toward the cursor on primary CTA buttons.
  function initMagneticButtons() {
    if (reduceMotion || matchMedia('(hover: hover)').matches === false) return;

    var buttons = document.querySelectorAll('.max-hero__actions .max-btn');
    var strength = 0.25;

    buttons.forEach(function (btn) {
      btn.addEventListener('mousemove', function (event) {
        var rect = btn.getBoundingClientRect();
        var x = (event.clientX - rect.left - rect.width / 2) * strength;
        var y = (event.clientY - rect.top - rect.height / 2) * strength;
        btn.style.transform = 'translate(' + x + 'px, ' + (y - 2) + 'px)';
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  // Live countdown to a target date (used on the coming-soon page).
  function initCountdown() {
    var els = document.querySelectorAll('[data-max-countdown]');
    if (!els.length) return;

    els.forEach(function (el) {
      var target = new Date(el.getAttribute('data-max-countdown'));
      if (isNaN(target.getTime())) return;

      var daysEl = el.querySelector('[data-countdown-days]');
      var hoursEl = el.querySelector('[data-countdown-hours]');
      var minutesEl = el.querySelector('[data-countdown-minutes]');
      var secondsEl = el.querySelector('[data-countdown-seconds]');

      function pad(n) {
        return String(n).length < 2 ? '0' + n : String(n);
      }

      function bump(node, nextValue) {
        if (node.textContent === nextValue) return;
        node.textContent = nextValue;
        if (reduceMotion) return;
        node.classList.remove('is-ticking');
        // eslint-disable-next-line no-unused-expressions
        node.offsetWidth; // restart the animation
        node.classList.add('is-ticking');
      }

      function update() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) {
          bump(daysEl, '00');
          bump(hoursEl, '00');
          bump(minutesEl, '00');
          bump(secondsEl, '00');
          window.clearInterval(timer);
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        bump(daysEl, pad(days));
        bump(hoursEl, pad(hours));
        bump(minutesEl, pad(minutes));
        bump(secondsEl, pad(seconds));
      }

      update();
      var timer = window.setInterval(update, 1000);
    });
  }

  // Subtle cursor-reactive drift on the coming-soon photo — this page
  // doesn't scroll, so scroll-linked parallax alone would be static.
  function initCursorParallax() {
    if (reduceMotion || matchMedia('(hover: hover)').matches === false) return;

    var targets = document.querySelectorAll('[data-max-cursor-parallax]');
    if (!targets.length) return;

    targets.forEach(function (el) {
      var media = el.querySelector('.max-hero__media');
      if (!media) return;

      var current = { x: 0, y: 0 };
      var target = { x: 0, y: 0 };

      el.addEventListener('mousemove', function (event) {
        var rect = el.getBoundingClientRect();
        target.x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        target.y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      });

      el.addEventListener('mouseleave', function () {
        target.x = 0;
        target.y = 0;
      });

      function tick() {
        current.x += (target.x - current.x) * 0.06;
        current.y += (target.y - current.y) * 0.06;
        media.style.transform = 'scale(1.05) translate(' + (current.x * -26).toFixed(2) + 'px, ' + (current.y * -20).toFixed(2) + 'px)';
        window.requestAnimationFrame(tick);
      }

      window.requestAnimationFrame(tick);
    });
  }

  // Cursor-tracked 3D tilt on cards/photos — product cards, gallery
  // frames, banners. The element rotates toward the cursor within a
  // small range, giving flat imagery a sense of physical depth.
  function initTiltHover() {
    if (reduceMotion || matchMedia('(hover: hover)').matches === false) return;

    var targets = document.querySelectorAll('[data-max-tilt]');
    if (!targets.length) return;

    var maxDegrees = 8;

    targets.forEach(function (el) {
      el.addEventListener('mousemove', function (event) {
        var rect = el.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        var rotateY = (x * maxDegrees * 2).toFixed(2);
        var rotateX = (y * maxDegrees * -2).toFixed(2);
        el.style.transform =
          'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale3d(1.02, 1.02, 1.02)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      });
    });
  }

  // Rich-text fields render as one HTML blob (a single <p> per paragraph,
  // but no way to attach per-paragraph animation classes from Liquid).
  // This finds each paragraph inside [data-max-split-reveal] and gives it
  // its own staggered 3D tilt-in reveal, self-contained (its own
  // IntersectionObserver) rather than depending on Dawn's scroll-trigger
  // timing for elements that don't exist until this script runs.
  function initSplitReveal() {
    var containers = document.querySelectorAll('[data-max-split-reveal]');
    if (!containers.length) return;

    var paragraphs = [];
    containers.forEach(function (container) {
      Array.prototype.forEach.call(container.children, function (child) {
        paragraphs.push(child);
      });
    });
    if (!paragraphs.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      return;
    }

    paragraphs.forEach(function (p, index) {
      p.classList.add('scroll-trigger', 'animate--tilt-in', 'scroll-trigger--offscreen');
      p.style.setProperty('--animation-order', index);
      p.style.transitionDelay = index * 120 + 'ms';
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('scroll-trigger--offscreen');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    paragraphs.forEach(function (p) {
      observer.observe(p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initParallax();
      initHeaderScrollState();
      initSmoothAnchors();
      initMagneticButtons();
      initCountdown();
      initCursorParallax();
      initTiltHover();
      initSplitReveal();
    });
  } else {
    initParallax();
    initHeaderScrollState();
    initSmoothAnchors();
    initMagneticButtons();
    initCountdown();
    initCursorParallax();
    initTiltHover();
    initSplitReveal();
  }
})();
